import React, { useState, useEffect } from "react";
// import { Card, CardHeader, Container, Row } from "reactstrap";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";

import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Container,
  FormGroup,
  FormText,
  Form,
  Input,
  Label,
  Row,
  Col,
} from "reactstrap";
import AcademicModal from "models/academic.modal";
import { helper } from "lib/helper";
import VideoQueModal from "models/VideoQue.modal";
const AddVideoQuestionManagment = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [dataList, setDataList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);

  const [perPage, setPerPage] = useState(20);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  const parameters = {};
  for (let [key, value] of searchParams) {
    parameters[key] = value;
  }
  const parmas = useParams();
  const [databyidBoard, setDatabyidBoard] = useState([]);
  const [databyidClass, setDatabyidClass] = useState([]);
  const [databyidSubject, setDatabyidSubject] = useState([]);
  const [addsLoadig, setAddsLoadig] = useState(false);

  const getListData = async () => {
    setIsLoading(true);
    await AcademicModal.list(parameters)

      .then((result) => {
        // console.log("here", result);
        setIsLoading(false);
        if (result) {
          setIsLoading(false);
          setDataList(result?.data);

          setCurrentPage(result?.meta?.current_page);
          setPerPage(result?.meta?.per_page);
        }
      })
      .catch((error) => {
        // helper.sweetalert.toast(error.response?.data?.message, "warning");
        setIsLoading(false);
      });
  };
  useEffect(() => {
    getListData();
  }, [location]);

  const [subjectId, setSubjectId] = useState("");
  const getListDataByid = async (id, name) => {
    setIsLoading(true);
    await AcademicModal.listbyidAcademicSubCategory(id)
      .then((result) => {
        // console.log("here", result);
        setIsLoading(false);
        if (result) {
          if (name == "board") {
            setDatabyidBoard(result?.data?.data);
            setDatabyidClass([]);
          }
          if (name == "class") {
            setDatabyidClass(result?.data?.data);
            setDatabyidSubject([]);
          }
          if (name == "subject") {
            setDatabyidSubject(result?.data?.data);
          }

          setCurrentPage(result?.meta?.current_page);
          setPerPage(result?.meta?.per_page);
        }
      })
      .catch((error) => {
        setIsLoading(false);
        helper.sweetalert.toast(error?.response?.data?.message, "warning");
      });
  };

  const navigate = useNavigate();
  const [questions, setQuestions] = useState(Array(20).fill(""));

  // Function to handle changes in input fields
  const handleInputChange = (index, value) => {
    const updatedQuestions = [...questions];
    updatedQuestions[index] = value;
    setQuestions(updatedQuestions);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    // Filter out empty questions
    const filledQuestions = questions.filter(question => question.trim() !== '');
    // Prepare FormData object
    const form = new FormData(event.target);
    form.append("catid", subjectId ?subjectId :setDatabyidClass ? setDatabyidClass :setDatabyidBoard);
    // Append each filled question separately 
    filledQuestions.forEach((question, index) => {
      form.append("questions[]", question);
    });
    // Send the FormData object to the server if there are filled questions
    if (filledQuestions.length > 0) {
      setAddsLoadig(true)
      VideoQueModal.create(form)
        .then((response) => {
          console.log(response, "response");
          helper.sweetalert.toast(
            "Your Video Questions Management  add.",
            "success"
          );
          navigate(`/admin/videoquestionsmanagement`);
          setAddsLoadig(false);
        })
        .catch((error) => {
          navigate(`/admin/videoquestionsmanagement`);
          setAddsLoadig(false);
        });
    } else {
      alert('Please fill in at least one question.');
    }
  };
  

  const pairs = [];
  for (let i = 0; i < questions.length; i += 2) {
    pairs.push([questions[i], questions[i + 1]]);
  }

  return (
    <>
      <Container className="pt-7">
        <Row>
          <div className="col">
            <Card className="shadow">
              <CardHeader className="border-0 d-flex justify-content-between ">
                <h3 className="mb-0">Add Video Questions</h3>
              </CardHeader>
              <CardBody>
                <Form onSubmit={handleSubmit}>
                  <Row>
                    {/* <Col md={6}>
                        <FormGroup>
                          <Label for="exampleEmail">Category </Label>
                          <Input
                            style={{
                              border: "1px solid lightgrey",
                              padding: "6px 10px",
                              borderRadius: "6px",
                            }}
                            id="name"
                            name="question"
                            placeholder="Category Name"
                          />
                        </FormGroup>
                      </Col> */}
                    <Col md={6}>
                      <FormGroup>
                        <Label for="exampleEmail">Type</Label>
                        <Input
                          id="forType"
                          // name="type"
                          type="select"
                          onChange={(e) => {
                            getListDataByid(e.target.value, "board");
                            setDatabyidBoard([]);
                            setDatabyidClass([]);
                            setDatabyidSubject([]);
                            setSubjectId(e.target.value)
                          }}
                        >
                          <option value="">select option</option>
                          {dataList &&
                            dataList?.map((item, index) => {
                              return (
                                <option value={item.id}>{item.name}</option>
                              );
                            })}
                        </Input>
                      </FormGroup>
                    </Col>

                    {/* <Col md={6}>
                      <FormGroup>
                        <Label for="exampleEmail">Board</Label>
                        <Input
                          style={{
                            border: "1px solid lightgrey",
                            padding: "6px 10px",
                            borderRadius: "6px",
                          }}
                          id="name"
                          name="question"
                          placeholder="Board"
                        />
                      </FormGroup>
                    </Col> */}
                    <Col md={6}>
                      <FormGroup>
                        <Label for="forType">Board</Label>
                        <Input
                          id="forType"
                          // name="type"
                          type="select"
                          onChange={(e) => {
                            getListDataByid(e.target.value, "class");
                            setDatabyidClass([]);
                            setDatabyidSubject([]);
                            setSubjectId(e.target.value)
                          }}
                        >
                          <option value="">select option</option>
                          {databyidBoard &&
                            databyidBoard?.map((item, index) => {
                              return (
                                <option value={item.id}>{item.name}</option>
                              );
                            })}
                        </Input>
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={6}>
                      <FormGroup>
                        <Label for="forType">Class</Label>
                        <Input
                          id="forType"
                          // name="type"
                          type="select"
                          onChange={(e) => {
                            getListDataByid(e.target.value, "subject");
                            setDatabyidSubject([])
                            setSubjectId(e.target.value)
                          }}
                        >
                          <option value="">select option</option>
                          {databyidClass &&
                            databyidClass.map((item, index) => {
                              return (
                                <option value={item.id}>{item.name}</option>
                              );
                            })}
                        </Input>
                      </FormGroup>
                    </Col>
                    <Col md={6}>
                      <FormGroup>
                        <Label for="forType">Subject</Label>
                        <Input
                          id="forType"
                          // name="type"
                          type="select"
                          onChange={(e) => setSubjectId(e.target.value)}
                        >
                          <option value="">select option</option>
                          {databyidSubject &&
                            databyidSubject?.map((item, index) => {
                              return (
                                <option value={item.id}>{item.name}</option>
                              );
                            })}
                        </Input>
                      </FormGroup>
                    </Col>
                  </Row>
                  {/* <Row>
                    <Col md={6}>
                      <FormGroup>
                        <Label for="exampleEmail">Question 1</Label>
                        <Input
                          id="type"
                          name = 'questions[]'
                          type="textarea"
                          placeholder="Enter Question"
                        />
                      </FormGroup>
                    </Col>
                    <Col md={6}>
                      <FormGroup>
                        <Label for="exampleEmail">Question 2</Label>
                        <Input
                          id="type"
                          name = 'questions[]'
                          type="textarea"
                          placeholder="Enter Question"
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={6}>
                      <FormGroup>
                        <Label for="exampleEmail">Question 3</Label>
                        <Input
                          id="type"
                          name = 'questions[]'
                          type="textarea"
                          placeholder="Enter Question"
                        />
                      </FormGroup>
                    </Col>
                    <Col md={6}>
                      <FormGroup>
                        <Label for="exampleEmail">Question 4</Label>
                        <Input
                          id="type"
                          name = 'questions[]'
                          type="textarea"
                          placeholder="Enter Question"
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={6}>
                      <FormGroup>
                        <Label for="exampleEmail">Question 5</Label>
                        <Input
                          id="type"
                          name = 'questions[]'
                          type="textarea"
                          placeholder="Enter Question"
                        />
                      </FormGroup>
                    </Col>
                    <Col md={6}>
                      <FormGroup>
                        <Label for="exampleEmail">Question 6</Label>
                        <Input
                          id="type"
                          name = 'questions[]'
                          type="textarea"
                          placeholder="Enter Question"
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={6}>
                      <FormGroup>
                        <Label for="exampleEmail">Question 7</Label>
                        <Input
                          id="type"
                          name = 'questions[]'
                          type="textarea"
                          placeholder="Enter Question"
                        />
                      </FormGroup>
                    </Col>
                    <Col md={6}>
                      <FormGroup>
                        <Label for="exampleEmail">Question 8</Label>
                        <Input
                          id="type"
                          name = 'questions[]'
                          type="textarea"
                          placeholder="Enter Question"
                        />
                      </FormGroup>
                    </Col>
                  </Row> */}
                  {/* <Row>
                    <Col md={6}>
                      <FormGroup>
                        <Label for="exampleEmail">Question 9</Label>
                        <Input
                          id="type"
                          // name="question"
                          type="textarea"
                          placeholder="Enter Question"
                        />
                      </FormGroup>
                    </Col>
                    <Col md={6}>
                      <FormGroup>
                        <Label for="exampleEmail">Question 10</Label>
                        <Input
                          id="type"
                          // name="question"
                          type="textarea"
                          placeholder="Enter Question"
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={6}>
                      <FormGroup>
                        <Label for="exampleEmail">Question 11</Label>
                        <Input
                          id="type"
                          // name="question"
                          type="textarea"
                          placeholder="Enter Question"
                        />
                      </FormGroup>
                    </Col>
                    <Col md={6}>
                      <FormGroup>
                        <Label for="exampleEmail">Question 12</Label>
                        <Input
                          id="type"
                          // name="question"
                          type="textarea"
                          placeholder="Enter Question"
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={6}>
                      <FormGroup>
                        <Label for="exampleEmail">Question 13</Label>
                        <Input
                          id="type"
                          // name="question"
                          type="textarea"
                          placeholder="Enter Question"
                        />
                      </FormGroup>
                    </Col>
                    <Col md={6}>
                      <FormGroup>
                        <Label for="exampleEmail">Question 14</Label>
                        <Input
                          id="type"
                          // name="question"
                          type="textarea"
                          placeholder="Enter Question"
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={6}>
                      <FormGroup>
                        <Label for="exampleEmail">Question 15</Label>
                        <Input
                          id="type"
                          // name="question"
                          type="textarea"
                          placeholder="Enter Question"
                        />
                      </FormGroup>
                    </Col>
                    <Col md={6}>
                      <FormGroup>
                        <Label for="exampleEmail">Question 16</Label>
                        <Input
                          id="type"
                          // name="question"
                          type="textarea"
                          placeholder="Enter Question"
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={6}>
                      <FormGroup>
                        <Label for="exampleEmail">Question 17</Label>
                        <Input
                          id="type"
                          // name="question"
                          type="textarea"
                          placeholder="Enter Question"
                        />
                      </FormGroup>
                    </Col>
                    <Col md={6}>
                      <FormGroup>
                        <Label for="exampleEmail">Question 18</Label>
                        <Input
                          id="type"
                          // name="question"
                          type="textarea"
                          placeholder="Enter Question"
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={6}>
                      <FormGroup>
                        <Label for="exampleEmail">Question 19</Label>
                        <Input
                          id="type"
                          // name="question"
                          type="textarea"
                          placeholder="Enter Question"
                        />
                      </FormGroup>
                    </Col>
                    <Col md={6}>
                      <FormGroup>
                        <Label for="exampleEmail">Question 20</Label>
                        <Input
                          id="type"
                          // name="question"
                          type="textarea"
                          placeholder="Enter Question"
                        />
                      </FormGroup>
                    </Col>
                  </Row> */}

                  {[...Array(10)]?.map((_, rowIndex) => (
                    <Row key={rowIndex}>
                      {[0, 1]?.map((colIndex) => {
                        const questionIndex = rowIndex * 2 + colIndex;
                        return (
                          <Col md={6} key={colIndex}>
                            <FormGroup>
                              <Label
                                for={`question${questionIndex + 1}`}
                              >{`Question ${questionIndex + 1}`}</Label>
                              <Input
                                id={`question${questionIndex + 1}`}
                                type="textarea"
                                // name = 'questions[]'
                                placeholder="Enter Question"
                                value={questions[questionIndex]}
                                onChange={(e) =>
                                  handleInputChange(
                                    questionIndex,
                                    e.target.value
                                  )
                                }
                              />
                            </FormGroup>
                          </Col>
                        );
                      })}
                    </Row>
                  ))}
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <Button
                      color="secondary"
                      to="/admin/videoquestionsmanagement"
                      tag={Link}
                    >
                      Cancel
                    </Button>
                    {/* 
                      {addsLoadig ? (
                        <Loader color={"blue"} />
                      ) : ( */}
                    <Button
                      color="primary"
                      type="submit"
                      style={{ float: "right", marginLeft: "5%" ,backgroundColor:"#080278",color:"white",border:"none"}}
                    >
                      Save
                    </Button>
                    {/* )} */}
                  </div>
                </Form>
              </CardBody>
            </Card>
          </div>
        </Row>
      </Container>
    </>
  );
};

export default AddVideoQuestionManagment;
